import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import 'react';
import { usePopoverContext } from './context.js';
import { PopoverContainer } from './PopoverContainer.js';
import { PopoverArrow } from './PopoverArrow.js';
import { mobilePosition } from './plugins.js';
import { jsx } from '@emotion/react';
import { Tooltip } from '../Tooltip/Tooltip.js';
import '@indeed/ihl-use-id';
import '@indeed/ifl-icons';
import '../Button/Button.js';
import 'focus-visible';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../../constants/index.js';
import '../../utils/createResponsive.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../Menu/MenuOverlay.js';
import '../Tooltip/TippyTooltip.js';
import '@tippyjs/react/headless';
import '../Tooltip/Arrow.js';
import '../Tooltip/plugins.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../AccessibleTrap/AccessibleTrap.js';
import 'react-remove-scroll';
import '../AccessibleTrap/FocusTrap.js';
import 'react-focus-lock';
import '../../hooks/useInertA11yBackground.js';
import '../../hooks/useForceUpdate.js';
import '../Tooltip/PopupTooltip.js';
import '../../index-26fc6478.js';
import '../../utils/mergeRefs.js';
import 'use-debounce';
import '../Popup/Popup.js';
import '@floating-ui/react-dom';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';
import '../Portal/Portal.js';
import 'react-dom';

/**
 * PopoverContent
 *
 * @deprecated The `Popover` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 **/
const PopoverContent = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const {
    getTooltipProps,
    isMobile
  } = usePopoverContext();
  return jsx(Tooltip, _extends({
    offset: [0, 12],
    inverse: true,
    popupComponent: PopoverContainer,
    arrowComponent: PopoverArrow,
    role: "dialog",
    label: children,
    popperOptions: isMobile ? {
      modifiers: [mobilePosition]
    } : undefined,
    aria: {
      // @ts-ignore
      content: "controls",
      expanded: true
    },
    touch: true
  }, getTooltipProps(), props));
};
PopoverContent.displayName = "PopoverContent";

export { PopoverContent };
